// extracted by mini-css-extract-plugin
export var title = "text-highlights-module--title--31020";
export var titleHighlights = "text-highlights-module--title-highlights--97149";